import { ISpotlight } from "./Spotlight.interfaces";

export const SPOTLIGHT_DISPLAY_TIMEOUT_IN_MILLISECONDS = 1500;

export const SPOTLIGHT_ITEMS: ISpotlight = {
  run: true,
  steps: [
    {
      content: <p>Welcome! Let us show you how to get the most out of this website. Click next to continue.</p>,
      locale: { skip: <strong aria-label="skip">Skip</strong> },
      placement: 'center',
      target: 'body',
      title: 'Welcome',
      showSkipButton: false,
    },
    {
      content: <p>
      Complete one 20-minute module each week (12-minute podcast plus short activities) 
      </p>,
      target: '.c-spotlight--modules',
      title: 'Modules',
      placement: 'auto',
    },
    {
      content: <p>
      Revisit the module content anytime by clicking ‘Review’.  
      </p>,
      target: '.c-spotlight--review',
      title: 'Review',
      placement: 'auto',
    },
    {
      content: <p>
      See a summary of the top parenting strategies you want to try, and the goals you set.  
      </p>,
      target: '.c-spotlight--summary',
      title: 'Summary',
      placement: 'auto',
      disableScrolling: true
    },
    {
      content: <p>
      Click this button to hear any content out loud.  
      </p>,
      target: '.js-kanzi-play-button',
      title: 'Kanzi Tool',
      placement: 'auto',
      disableScrolling: true
    },
    {
      content: <p>
      Click this button to translate this website into other languages. 
      </p>,
      target: '.js-kanzi-translate-button',
      title: 'Kanzi Tool',
      placement: 'auto',
      disableScrolling: true
    },
    {
      content: <p>
      Click this button to download any page as a PDF.
      </p>,
      target: '.js-kanzi-pdf-button',
      title: 'Kanzi Tool',
      placement: 'auto',
      disableScrolling: true
    },
    {
      content: <p>
      Click this button to change how the page looks (e.g., increase font size). 
      </p>,
      target: '.js-kanzi-accessibility-button',
      title: 'Kanzi Tool',
      placement: 'auto',
      disableScrolling: true
    },
    {
      content: <p>
      Book a 15-minute telephone session with our health coach for extra support.  
      </p>,
      target: '.c-spotlight--health-coach',
      title: 'Book a health Coach',
      placement: 'auto',
    },
    {
      content: <p>
      Quickly access where you left-off, the last time you logged out. 
      </p>,
      target: '.c-spotlight--quick-access',
      title: 'Quick Access',
      placement: 'auto',
    },
    {
      content: <p>
      See the goal you set during each module. 
      </p>,
      target: '.c-spotlight--goals',
      title: 'Goals',
      placement: 'auto',
    },
    {
      content: <p>
      See feedback on your current parenting strategies from each module.  
      </p>,
      target: '.c-spotlight--feedback',
      title: 'Feedback',
      placement: 'auto',
    },
    {
      content: <p>
      Find useful resources and further help here. 
      </p>,
      target: '.c-spotlight--resources',
      title: 'Resources',
      placement: 'auto',
    },
    {
      content: <p>
      Click here for quick access to crisis and mental health support services.
      </p>,
      target: '.c-spotlight--help',
      title: 'Get Help Now',
      placement: 'auto',
      disableScrolling: true
    },
  ],
};